__turbopack_context__.v({
  "aboutUs": "about-us-module-scss-module__UCmcma__aboutUs",
  "circle": "about-us-module-scss-module__UCmcma__circle",
  "line": "about-us-module-scss-module__UCmcma__line",
  "lineItem": "about-us-module-scss-module__UCmcma__lineItem",
  "subtext": "about-us-module-scss-module__UCmcma__subtext",
});
